// @ts-nocheck

import React, { useState, useEffect } from "react";
import NextImage from "next/image";
import useSWR from "swr";
import axios from "src/libs/axios";
// components
// eslint-disable-next-line max-len
import TotalRatingContainer from "src/components/containers/reviews/sections/TotalRating/TotalRating";
// eslint-disable-next-line max-len
import VisitorRatingContainer from "src/components/containers/reviews/sections/VisitorRating/VisitorRating";
// eslint-disable-next-line max-len
import ReviewsCardsContainer from "src/components/containers/reviews/sections/Reviews/Reviews";
import KnownForContainer from "src/components/containers/reviews/sections/knownFor/KnownFor";
// hooks
import { useRouter } from "next/router";
import { useClinic } from "src/hooks/requests/clinics";
import { useReviews } from "src/hooks/requests/reviews";
// types
import { TClinicDetails } from "src/types";
// utils
import { calcAvgRating } from "src/utils/reviews";
// const
import { ENDPOINTS } from "src/constants/endpoints";
// styles
import {
  BackButtonWrapper,
  BackButtonImageWrapper,
  BackButtonText,
  ContentWrapper,
  ClinicsName,
  TotalRaitingWrapper,
  TotalRatingStickyBox,
} from "./reviews.styles";

interface IClinicPage {
  clinic: TClinicDetails;
  reviews: any;
  reviewsStatistic: any;
  reviewsCount: any;
}

const ReviewsContainer = ({ clinic, reviews, reviewsStatistic, reviewsCount }: IClinicPage) => {
  const router = useRouter();
  const [visitorRating, setVisitorRating] = useState([]);
  const { clinic: clinicData = {} } = useClinic(clinic.id, clinic);
  const { reviews: reviewsData = [] } = useReviews(
    clinic.id,
    { rating: visitorRating, _start: router.query._start },
    reviews,
  );
  const { GET } = ENDPOINTS;
  const [statistic, setStatistic] = useState({});

  const avgRating = calcAvgRating(statistic.rating);

  useEffect(() => {
    axios
      .get(
        `${GET.reviewsStatistic}?clinic=${
          clinic.slug.startsWith("/") ? clinic.slug : `/${clinic.slug}`
        }`,
      )
      .then((respons) => setStatistic(respons.data));
  }, []);

  if (Object.keys(statistic).length === 0) return null;

  return (
    <ContentWrapper>
      <BackButtonWrapper onClick={() => router.back()}>
        <BackButtonImageWrapper>
          <NextImage src="/icons/arrow-left-black.svg" width={13.5} height={13.5} />
        </BackButtonImageWrapper>
        <BackButtonText>Back</BackButtonText>
      </BackButtonWrapper>

      <ClinicsName>{clinicData.name} reviews</ClinicsName>
      <TotalRaitingWrapper>
        <TotalRatingStickyBox>
          <TotalRatingContainer reviewsCount={reviewsCount} avgRating={avgRating} clinic={clinic} />
        </TotalRatingStickyBox>
      </TotalRaitingWrapper>
      <VisitorRatingContainer
        setVisitorRating={setVisitorRating}
        reviewsStatistic={statistic}
        reviewsCount={reviewsCount}
      />
      {!!reviewsStatistic.reasons.length && (
        <KnownForContainer reasons={reviewsStatistic.reasons} />
      )}
      <ReviewsCardsContainer reviews={reviewsData} reviewsCount={reviewsCount} />
    </ContentWrapper>
  );
};

export default ReviewsContainer;
